// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"_1fpHQ0wGBeW5aL-01IljMZ","icon":"_1T4US_lUZY3jm83xrlrXPX","active":"_19cI_zhZYjx7-NrwVkDgs6"};